import "../assets/css/resume.css";
import React, { useEffect } from "react";
import { animation, headerSet, showNavLink } from "../Helper/CssHelper";
// import ResumeData from "../data/ResumeData";

function Resume(props) {
  const ResumeData = props.ResumeData;

  useEffect(() => {
    headerSet("Resume | Justin Dsouza");
    showNavLink("resume", "resume-section");
    animation("resume-section");
  }, []);
  return (
    <div>
      <section id="resume-section" className="resume section-show">
        <div className="container">
          <div className="section-title">
            <h2>Resume</h2>
            <p>Check My Resume</p>
          </div>
          <div className="row">
            <div className="col-lg-6">
              {ResumeData.Summary && (
                <div>
                  <h3 className="resume-title">
                    {ResumeData.Summary.columnName}
                  </h3>
                  <div className="resume-item pb-0">
                    <h4>{ResumeData.Summary.name}</h4>
                    <p>
                      <em>{ResumeData.Summary.shortDescription}</em>
                    </p>
                    <ul>
                      {ResumeData.Summary &&
                        ResumeData.Summary.points.map((point, index) => {
                          return <li key={index}>{point.value}</li>;
                        })}
                    </ul>
                  </div>
                </div>
              )}
              {ResumeData.leftInfo &&
                ResumeData.leftInfo.map((item, index) => {
                  return (
                    <div key={index}>
                      <h3 className="resume-title">{item.name}</h3>
                      {item &&
                        item.values.map((experience, index) => {
                          return (
                            <div className="resume-item" key={index}>
                              <h4>{experience.title}</h4>
                              <h5>{experience.years}</h5>
                              <p>
                                <em>{experience.organization}</em>
                              </p>
                              <ul>
                                {experience.points &&
                                  experience.points.map((point, index) => {
                                    return <li key={index}>{point.value}</li>;
                                  })}
                              </ul>
                              {experience.shortParagraph && (
                                <p>{experience.shortParagraph}</p>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
            </div>
            <div className="col-lg-6">
              {ResumeData.rightInfo &&
                ResumeData.rightInfo.map((item, index) => {
                  return (
                    <div key={index}>
                      <h3 className="resume-title">{item.name}</h3>
                      {item &&
                        item.values.map((experience, index) => {
                          return (
                            <div className="resume-item" key={index}>
                              <h4>{experience.title}</h4>
                              <h5>{experience.years}</h5>
                              <p>
                                <em>{experience.organization}</em>
                              </p>
                              <ul>
                                {experience.points &&
                                  experience.points.map((point, index) => {
                                    return <li key={index}>{point.value}</li>;
                                  })}
                              </ul>
                              {experience.shortParagraph && (
                                <p>{experience.shortParagraph}</p>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  );
                })}
            </div>
          </div>
          {ResumeData.ResumeLink && (
            <div className="row">
              <div className="text-center">
                <a
                  className="btn-resume"
                  href={ResumeData.ResumeLink.Link}
                  target="_blank"
                  rel="noreferrer"
                >
                  Resume.pdf
                </a>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Resume;
